import React from 'react';
type BowIconProps = {
  className?: string;
};
export function BowIcon({
  className = 'h-4 w-4'
}: BowIconProps) {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" strokeLinecap="round" className={className} aria-hidden="true" data-id="element-14" data-mp="y4geq7ayikdq">
      <path d="M12 10.5C9.5 7 5.5 5 4 6.5S4.5 13 12 10.5Z" data-id="element-15" data-mp="17zrrik2t1hiu" />
      <path d="M12 10.5C14.5 7 18.5 5 20 6.5S19.5 13 12 10.5Z" data-id="element-16" data-mp="1c2epl2q2jyoh" />
      <path d="M11 11.5 8 20l2.2-1.2L11.6 21l.4-9.5" data-id="element-17" data-mp="1h2j3ckzlefb0" />
      <path d="M13 11.5 16 20l-2.2-1.2L12.4 21" data-id="element-18" data-mp="1h0yd37kb9iiy" />
      <circle cx="12" cy="10.8" r="1.4" fill="currentColor" data-id="element-19" data-mp="1ltj5c4nkjnkd" />
    </svg>;
}